import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'
import Typography from '../typography'

export const TableWrapper = styled('div')<{ theme?: TTheme }>`
    .tbody {
        background-color: var(--color-greys-0);
    }
`
export const HeaderText = styled(Typography)<{ theme?: TTheme }>`
    color: var(--color-greys-600);
    margin: 12px 0;
    div {
        justify-content: flex-start !important;
    }
`

export const Cell = styled('div')<{
    theme?: TTheme
    padding?: string
    cursor?: string
}>`
    height: 60px;
    flex: 1;
    margin: 0;
    width: 100%;
    display: flex;
    align-items: center;
    cursor: ${({ cursor }) => cursor || 'pointer'};
`

export const NavigationTitle = styled(Typography)<{ theme?: TTheme }>`
    display: flex !important;
    gap: 16px;
    align-content: center;
    align-items: center;
    padding-left: 40px;
`
